import { render, staticRenderFns } from "./CancelPolicy.vue?vue&type=template&id=99c94ff0"
import script from "./CancelPolicy.vue?vue&type=script&lang=js"
export * from "./CancelPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports